var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._l((_vm.value),function(tag,i){return [(tag.includes('[[') && tag.includes(']]'))?_c('span',{key:i,staticClass:"font-weight-medium indigo--text"},[_vm._v("\n      "+_vm._s(_vm.getUser(tag)))]):_c('span',{key:i,staticClass:"font-weight-regular",domProps:{"innerHTML":_vm._s(_vm.htmlComment(tag))}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }